import React from "react";
import Modal from "../modal/Modal";
import "./ResumeModal.scss";
import {greeting} from "../../portfolio";

export default function ResumeModal({isOpen, onClose, isDark}) {
  const resumeUrl = greeting.resumeLink;
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isDark={isDark}
      ariaLabel="Resume of Hamza Naseer"
    >
      <div className="resume-modal">
        <div className="resume-modal-header">
          <h2 className="resume-modal-title">My Resume</h2>
          <div className="resume-modal-actions">
            <a
              className="resume-action-btn"
              href={resumeUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fas fa-external-link-alt" aria-hidden="true"></i>{" "}
              Open
            </a>
            <a
              className="resume-action-btn resume-action-primary"
              href={resumeUrl}
              download="Hamza-Naseer-Resume.pdf"
            >
              <i className="fas fa-download" aria-hidden="true"></i> Download
            </a>
          </div>
        </div>
        <iframe
          className="resume-frame"
          src={resumeUrl + "#view=FitH"}
          title="Hamza Naseer Resume"
        />
        <p className="resume-fallback">
          Can't see the preview?{" "}
          <a href={resumeUrl} target="_blank" rel="noopener noreferrer">
            Open the PDF in a new tab
          </a>
          .
        </p>
      </div>
    </Modal>
  );
}
